
import React, {Component} from "react";

class Layer extends Component{

    render() {
        return(
            <div className="container-fluid">
                JLCPCBのリンク先の図を参考に制作

            </div>
        );
    }
}
export default Layer;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/Layer.js